module.exports = __webpack_public_path__ + "static/media/status-up.7737d630.svg";